/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

interface IItem {
  analyst: string | undefined;
  id: number;
  has_dependency: boolean;
  dependency_date: string;
}

interface IData {
  key: string;
  value: any;
}[]

export const validateText = (
  data: IData[],
  setError: any
) => {
  const result = data?.filter(item => {
    const { analyst, id, has_dependency, dependency_date } = item?.value as unknown as IItem;

    console.log(has_dependency)
    console.log(dependency_date)
    
    const invalidAnalyst = (analyst?.trim()?.length ?? 0) < 3;

    const invalidDependencyDate = has_dependency && !dependency_date;

    if (invalidAnalyst) {
      setError((prev: any) => {
        return { ...prev, [`analyst_${id}` as keyof object]: "Campo obrigatório!" }
      });
    } else {
      setError((prev: any) => {
        return { ...prev, [`analyst_${id}` as keyof object]: undefined }
      });
    }

    if (invalidDependencyDate) {
      setError((prev: any) => {
        return { ...prev, [`dependency_date_${id}` as keyof object]: "Campo obrigatório quando a dependência está selecionada!" }
      });
    } else {
      setError((prev: any) => {
        return { ...prev, [`dependency_date_${id}` as keyof object]: undefined }
      });
    }

    return invalidAnalyst || invalidDependencyDate;
  }) ?? []

  const validated = result.length === 0;
  return validated;
}
